const reviewApproverTypeConstants = Object.freeze({
  ANY_ADMIN: 'any_admin',
  AUTO_APPROVAL: 'auto_approval'
});

export {
  reviewApproverTypeConstants,
};

